import { j as a } from "../../jsx-runtime-B6kdoens.js";
import { useRef as F, useState as M, useMemo as g, useCallback as c, useEffect as W } from "react";
import { c as B } from "../../index-CROKJrb5.js";
import { c as _, f as q } from "../../create-component-CBAeEoQ6.js";
import { Button as R } from "../Button/index.js";
import { a as o } from "../../as-num-DQjLjHSI.js";
import { MinusIcon as v } from "../Icon/icons/MinusIcon/index.js";
import { PlusIcon as G } from "../Icon/icons/PlusIcon/index.js";
const H = B({
  base: "cur-rounded-full cur-border-2 cur-flex cur-h-[3.5rem] cur-items-center cur-px-5 cur-gap-2 cur-bg-surface-neutral",
  variants: {
    disabled: {
      true: "cur-border-border-disabled",
      false: "cur-border-surface-brand-light"
    }
  }
}), J = B({
  base: "cur-w-0 cur-flex-1 cur-text-center cur-text-cta cur-font-bold cur-bg-transparent",
  variants: {
    disabled: {
      true: "cur-text-disabled",
      false: "cur-text-primary"
    }
  }
}), er = _(
  "NumberInput",
  q(
    ({
      children: L,
      className: E,
      defaultValue: k,
      disabled: l = !1,
      name: P,
      min: i = 0,
      max: h = 1 / 0,
      onChange: e,
      readOnly: A = !1,
      title: m,
      step: $ = 1,
      value: p,
      ...T
    }, U) => {
      const b = F(null), [z, x] = M(
        `${k || p || i}`
      ), [D, I] = M(
        o(k || p || i)
      ), d = g(() => o(i), [i]), N = g(() => o(h), [h]), n = g(() => o($), [$]), u = c(
        (r) => {
          const t = Math.max(Math.min(r, N), d), s = t % n;
          return s > 0 ? n / 2 < s ? t - s + n : t - s : t;
        },
        [d, N, n]
      ), w = c(
        (r, t) => {
          t.stopPropagation(), t.preventDefault();
          const s = {
            ...t,
            currentTarget: b.current,
            target: b.current
          }, f = u(
            D + n * r
          );
          s.target.value = `${f}`, I(f), x(`${f}`), e == null || e(s, f);
        },
        [u, D, n, e, b]
      ), j = c(
        (r) => w(-1, r),
        [w]
      ), y = c(
        (r) => w(1, r),
        [w]
      ), K = c(
        (r) => {
          r.stopPropagation(), x(r.target.value);
        },
        []
      ), V = c(
        (r) => {
          r.stopPropagation();
          const t = u(o(r.target.value || d));
          r.target.value = `${t}`, I(t), x(`${t}`), e == null || e(r, t);
        },
        [u, e, d]
      ), S = c(
        (r) => {
          switch (r.key) {
            case "Enter":
              return V(r);
            case "ArrowUp":
              return y(
                r
              );
            case "ArrowDown":
              return j(
                r
              );
          }
        },
        [V, y, j]
      );
      return W(() => {
        if (p !== void 0) {
          const r = u(o(p));
          I(r), x(`${r}`);
        }
      }, [u, p, n, d, N]), /* @__PURE__ */ a.jsxs(
        "div",
        {
          className: H({ className: E, disabled: l }),
          ref: U,
          ...T,
          children: [
            /* @__PURE__ */ a.jsx(
              R,
              {
                "aria-hidden": !0,
                buttonType: "text",
                className: "cur-h-8 cur-w-8 cur-shrink-0",
                disabled: l,
                icon: /* @__PURE__ */ a.jsx(v, {}),
                onClick: j,
                size: "sm",
                state: "brand",
                title: `Decrement${m ? ` ${m}` : ""}`
              }
            ),
            /* @__PURE__ */ a.jsx(
              "input",
              {
                className: J({ disabled: l }),
                disabled: l,
                max: h,
                min: i,
                name: P,
                onChange: K,
                onBlur: V,
                onKeyDown: S,
                readOnly: A,
                ref: b,
                step: $,
                title: m,
                type: "number",
                value: z
              }
            ),
            /* @__PURE__ */ a.jsx(
              R,
              {
                "aria-hidden": !0,
                buttonType: "text",
                className: "cur-h-8 cur-w-8 cur-shrink-0",
                disabled: l,
                icon: /* @__PURE__ */ a.jsx(G, {}),
                onClick: y,
                size: "sm",
                state: "brand",
                title: `Increment${m ? ` ${m}` : ""}`
              }
            )
          ]
        }
      );
    }
  )
);
export {
  er as NumberInput
};
//# sourceMappingURL=index.js.map
